import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      redirect: '/app',
    },
    {
      path: '/app',
      component: () => import('./containers/Dashboard.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        { path: '', redirect: 'dashboard' },
        /*
         Commenting this to leave for later as MVP will not support multi-business
        */
        // {
        //   path: 'business-overview',
        //   component: () => import('./views/dashboard/business-overview.vue'),
        //   meta: {
        //     displayName: 'Business Overview',
        //     iconPath: './assets/images/icons/home-icon.svg',
        //     showInNav: true,
        //   },
        // },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('./views/dashboard/dashboard.vue'),
          meta: {
            displayName: 'Dashboard',
            showInNav: true,
            sideBarIcon: 'HomeIcon',
          },
        },
        {
          path: 'customer-data',
          component: () => import('./views/dashboard/consumerData.vue'),
          meta: {
            displayName: 'Customers',
            sideBarIcon: 'UsersIcon',
            showInNav: true,
          },
        },
        {
          path: 'landing-page',
          name: 'landingPage',
          component: () => import('./views/dashboard/landingPage.vue'),
          meta: {
            displayName: 'Landing Page',
            sideBarIcon: 'FileIcon',
            showInNav: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Signup.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/ForgotPassword.vue'),
    },
    {
      path: '/fetchrev-connection-success',
      name: 'fetchrev-connection-success',
      component: () => import('./views/FetchRevConnectionSuccess.vue'),
    },
  ],
});
